import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.js";
import "./styles.css";
import "./pwa-pages.css";
import "./marketplace.css";
import "./catalog-controls.css";

const root = document.getElementById("root");
if (root === null) throw new Error("No se encontró el nodo raíz de PuntoPY Operaciones.");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);

if (import.meta.env.PROD && "serviceWorker" in navigator) {
  const controlledAtLoad = navigator.serviceWorker.controller !== null;
  let refreshingForUpdate = false;

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!controlledAtLoad || refreshingForUpdate) return;
    refreshingForUpdate = true;
    window.location.reload();
  });

  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" })
      .then((registration) => registration.update())
      .catch(() => {
        // La aplicación sigue funcionando en línea si el navegador bloquea el service worker.
      });
  });
}
